// Configuration SEO centralisée pour tous les métiers
export const seoConfig = {
  siteName: "LYS - Logiciel de Gestion pour Artisans",
  siteUrl: "https://lys-artisans.fr",
  defaultImage: "/images/lys-og-default.jpg",
  twitterHandle: "@LYSArtisans",
  
  // SEO par métier avec variations géographiques
  metiers: {
    electriciens: {
      title: "Logiciel Électricien - Devis, Planning & Facturation | LYS",
      metaDescription: "Logiciel de gestion pour électriciens : devis automatiques, planning interventions, facturation. Calculateur installation électrique inclus. Essai gratuit 14j.",
      keywords: [
        "logiciel électricien",
        "devis électricité automatique", 
        "planning électricien",
        "facturation électricité",
        "gestion chantier électrique",
        "calcul installation électrique",
        "CRM électricien",
        "comptabilité électricien"
      ],
      schema: {
        "@type": "SoftwareApplication",
        "name": "LYS Électriciens",
        "applicationCategory": "BusinessApplication",
        "operatingSystem": "Web, iOS, Android",
        "description": "Solution complète de gestion pour électriciens : devis, planning, facturation et suivi chantiers",
        "offers": {
          "@type": "Offer",
          "price": "29",
          "priceCurrency": "EUR",
          "priceValidUntil": "2025-12-31"
        }
      },
      cities: [
        { name: "Paris", population: "2M+", demand: "Très forte" },
        { name: "Lyon", population: "500K+", demand: "Forte" },
        { name: "Marseille", population: "850K+", demand: "Forte" },
        { name: "Toulouse", population: "450K+", demand: "Moyenne" },
        { name: "Nice", population: "340K+", demand: "Moyenne" },
        { name: "Nantes", population: "300K+", demand: "Moyenne" },
        { name: "Strasbourg", population: "280K+", demand: "Moyenne" },
        { name: "Montpellier", population: "270K+", demand: "Moyenne" }
      ]
    },
    
    plombiers: {
      title: "Logiciel Plombier - Urgences 24h, Devis & Planning | LYS",
      metaDescription: "Logiciel de gestion plombiers : urgences 24h/7j, devis automatiques, planning interventions, facturation. Module chauffage inclus. Essai gratuit.",
      keywords: [
        "logiciel plombier",
        "gestion urgences plomberie",
        "devis plomberie automatique",
        "planning plombier", 
        "facturation plomberie",
        "CRM plombier",
        "suivi chantier plomberie",
        "comptabilité plombier"
      ],
      schema: {
        "@type": "SoftwareApplication",
        "name": "LYS Plombiers",
        "applicationCategory": "BusinessApplication",
        "description": "Solution de gestion pour plombiers avec module urgences 24h/7j et suivi interventions",
        "offers": {
          "@type": "Offer", 
          "price": "29",
          "priceCurrency": "EUR"
        }
      },
      cities: [
        { name: "Paris", population: "2M+", demand: "Très forte" },
        { name: "Lyon", population: "500K+", demand: "Forte" },
        { name: "Marseille", population: "850K+", demand: "Forte" },
        { name: "Lille", population: "230K+", demand: "Moyenne" },
        { name: "Bordeaux", population: "250K+", demand: "Moyenne" },
        { name: "Toulouse", population: "450K+", demand: "Moyenne" },
        { name: "Nice", population: "340K+", demand: "Moyenne" },
        { name: "Nantes", population: "300K+", demand: "Moyenne" }
      ]
    },

    macons: {
      title: "Logiciel Maçon - Devis Automatique, Suivi Chantier | LYS", 
      metaDescription: "Logiciel de gestion maçons : devis automatiques gros œuvre, planning chantiers, facturation, photos avant/après. Calculateur matériaux inclus.",
      keywords: [
        "logiciel maçon",
        "devis maçonnerie automatique",
        "gestion chantier maçonnerie", 
        "planning maçon",
        "facturation maçonnerie",
        "CRM maçon",
        "calcul matériaux maçonnerie",
        "suivi travaux maçonnerie"
      ],
      schema: {
        "@type": "SoftwareApplication",
        "name": "LYS Maçons",
        "applicationCategory": "BusinessApplication",
        "description": "Solution de gestion pour maçons avec calculateur matériaux et suivi photo chantiers"
      },
      cities: [
        { name: "Paris", population: "2M+", demand: "Très forte" },
        { name: "Lyon", population: "500K+", demand: "Forte" },
        { name: "Marseille", population: "850K+", demand: "Forte" },
        { name: "Toulouse", population: "450K+", demand: "Moyenne" },
        { name: "Bordeaux", population: "250K+", demand: "Moyenne" },
        { name: "Lille", population: "230K+", demand: "Moyenne" },
        { name: "Strasbourg", population: "280K+", demand: "Moyenne" },
        { name: "Rennes", population: "220K+", demand: "Moyenne" }
      ]
    },

    coiffeurs: {
      title: "Logiciel Coiffeur - Prise RDV en Ligne, Planning & Caisse | LYS",
      metaDescription: "Logiciel de gestion salon coiffure : prise RDV en ligne 24h/7j, planning automatique, caisse tactile, fidélisation client. Essai gratuit.",
      keywords: [
        "logiciel coiffeur",
        "prise rdv coiffure en ligne",
        "planning salon coiffure",
        "caisse coiffeur",
        "gestion salon coiffure", 
        "CRM coiffeur",
        "fidélisation coiffure",
        "comptabilité coiffeur"
      ],
      schema: {
        "@type": "SoftwareApplication", 
        "name": "LYS Coiffeurs",
        "applicationCategory": "BusinessApplication",
        "description": "Solution complète pour salons de coiffure avec prise RDV en ligne et gestion client"
      },
      cities: [
        { name: "Paris", population: "2M+", demand: "Très forte" },
        { name: "Lyon", population: "500K+", demand: "Forte" },
        { name: "Marseille", population: "850K+", demand: "Forte" },
        { name: "Nice", population: "340K+", demand: "Forte" },
        { name: "Toulouse", population: "450K+", demand: "Moyenne" },
        { name: "Cannes", population: "75K+", demand: "Forte" },
        { name: "Bordeaux", population: "250K+", demand: "Moyenne" },
        { name: "Montpellier", population: "270K+", demand: "Moyenne" }
      ]
    },

    garagistes: {
      title: "Logiciel Garage Auto - Diagnostic, Devis & Planning | LYS",
      metaDescription: "Logiciel de gestion garage automobile : diagnostic intégré, devis réparation auto, planning atelier, facturation. Interface OBD incluse.",
      keywords: [
        "logiciel garage automobile",
        "diagnostic auto logiciel",
        "devis réparation auto",
        "planning garage",
        "gestion atelier auto",
        "CRM garagiste", 
        "facturation garage",
        "suivi véhicules"
      ],
      schema: {
        "@type": "SoftwareApplication",
        "name": "LYS Garagistes",
        "applicationCategory": "BusinessApplication", 
        "description": "Solution de gestion pour garages avec diagnostic intégré et suivi véhicules"
      },
      cities: [
        { name: "Paris", population: "2M+", demand: "Très forte" },
        { name: "Lyon", population: "500K+", demand: "Forte" },
        { name: "Marseille", population: "850K+", demand: "Forte" },
        { name: "Toulouse", population: "450K+", demand: "Moyenne" },
        { name: "Lille", population: "230K+", demand: "Moyenne" },
        { name: "Bordeaux", population: "250K+", demand: "Moyenne" },
        { name: "Strasbourg", population: "280K+", demand: "Moyenne" },
        { name: "Nantes", population: "300K+", demand: "Moyenne" }
      ]
    },

    jardiniers: {
      title: "Logiciel Jardinier Paysagiste - Devis & Planning | LYS",
      metaDescription: "Logiciel de gestion jardiniers paysagistes : devis espaces verts, planning interventions, facturation, photos avant/après. Module saisonnier.",
      keywords: [
        "logiciel jardinier paysagiste",
        "devis espaces verts",
        "planning jardinier",
        "gestion paysagiste",
        "facturation jardinage",
        "CRM jardinier",
        "suivi espaces verts",
        "planning saisonnier jardinage"
      ],
      schema: {
        "@type": "SoftwareApplication",
        "name": "LYS Jardiniers",
        "applicationCategory": "BusinessApplication",
        "description": "Solution de gestion pour jardiniers paysagistes avec planning saisonnier"
      },
      cities: [
        { name: "Paris", population: "2M+", demand: "Forte" },
        { name: "Lyon", population: "500K+", demand: "Moyenne" },
        { name: "Nice", population: "340K+", demand: "Forte" },
        { name: "Cannes", population: "75K+", demand: "Forte" },
        { name: "Toulouse", population: "450K+", demand: "Moyenne" },
        { name: "Bordeaux", population: "250K+", demand: "Moyenne" },
        { name: "Montpellier", population: "270K+", demand: "Moyenne" },
        { name: "Aix-en-Provence", population: "140K+", demand: "Moyenne" }
      ]
    },

    peintres: {
      title: "Logiciel Peintre Bâtiment - Devis m² & Planning | LYS", 
      metaDescription: "Logiciel de gestion peintres : calcul automatique m², devis peinture, planning chantiers, facturation. Nuancier digital inclus.",
      keywords: [
        "logiciel peintre bâtiment",
        "calcul m² peinture",
        "devis peinture automatique",
        "planning peintre",
        "gestion chantier peinture",
        "CRM peintre",
        "facturation peinture",
        "nuancier digital"
      ],
      schema: {
        "@type": "SoftwareApplication",
        "name": "LYS Peintres", 
        "applicationCategory": "BusinessApplication",
        "description": "Solution de gestion pour peintres avec calcul automatique surfaces et nuancier"
      }
    },

    menuisiers: {
      title: "Logiciel Menuisier - Devis Sur-Mesure & Plans 3D | LYS",
      metaDescription: "Logiciel de gestion menuisiers : devis menuiserie sur-mesure, plans 3D, planning fabrication, facturation. Catalogue matériaux inclus.",
      keywords: [
        "logiciel menuisier",
        "devis menuiserie sur-mesure", 
        "plans 3D menuiserie",
        "planning menuisier",
        "gestion atelier menuiserie",
        "CRM menuisier",
        "facturation menuiserie",
        "catalogue bois"
      ],
      schema: {
        "@type": "SoftwareApplication",
        "name": "LYS Menuisiers",
        "applicationCategory": "BusinessApplication",
        "description": "Solution de gestion pour menuisiers avec plans 3D et devis sur-mesure"
      }
    },

    // Continuer pour les autres métiers...
    fleuristes: {
      title: "Logiciel Fleuriste - Commandes & Livraisons | LYS",
      metaDescription: "Logiciel de gestion fleuristes : commandes en ligne, planning livraisons, stock fleurs, facturation. Module événementiel inclus.",
      keywords: ["logiciel fleuriste", "commandes fleurs en ligne", "planning livraisons", "stock fleurs", "gestion fleuriste"]
    },

    carreleurs: {
      title: "Logiciel Carreleur - Devis & Calcul Surfaces | LYS", 
      metaDescription: "Logiciel de gestion carreleurs : calcul automatique surfaces, devis carrelage, planning pose, facturation. Catalogue carreaux inclus.",
      keywords: ["logiciel carreleur", "calcul surface carrelage", "devis carrelage", "planning carreleur", "gestion carrelage"]
    },

    estheticiennes: {
      title: "Logiciel Esthéticienne - RDV & Soins Beauté | LYS",
      metaDescription: "Logiciel de gestion instituts beauté : prise RDV esthétique, planning soins, caisse, fidélisation. Fiche client beauté incluse.",
      keywords: ["logiciel esthéticienne", "rdv esthétique", "planning beauté", "gestion institut", "soins esthétiques"]
    },

    masseurs: {
      title: "Logiciel Masseur - Planning & Bien-Être | LYS",
      metaDescription: "Logiciel de gestion masseurs : prise RDV massage, planning praticien, facturation, fiche client bien-être. Module thérapeutique.",
      keywords: ["logiciel masseur", "rdv massage", "planning masseur", "gestion massage", "bien-être"]
    },

    menage: {
      title: "Logiciel Service Ménage - Planning & Facturation | LYS",
      metaDescription: "Logiciel de gestion services ménage : planning interventions, devis nettoyage, facturation, suivi clients. Module récurrent inclus.",
      keywords: ["logiciel service ménage", "planning ménage", "devis nettoyage", "gestion ménage", "nettoyage"]
    },

    carrossiers: {
      title: "Logiciel Carrossier - Devis & Réparations | LYS",
      metaDescription: "Logiciel de gestion carrossiers : devis carrosserie, photos dégâts, planning réparations, facturation. Module assurance inclus.",
      keywords: ["logiciel carrossier", "devis carrosserie", "réparation carrosserie", "gestion carrossier", "assurance auto"]
    },

    controle_technique: {
      title: "Logiciel Contrôle Technique - Planning & Rapports | LYS", 
      metaDescription: "Logiciel de gestion centres contrôle technique : planning contrôles, rapports automatiques, facturation, relances CT.",
      keywords: ["logiciel contrôle technique", "planning CT", "rapports contrôle", "gestion contrôle technique", "centre CT"]
    },

    ramoneurs: {
      title: "Logiciel Ramonage - Certificats & Planning | LYS",
      metaDescription: "Logiciel de gestion ramoneurs : planning ramonage, certificats automatiques, facturation, relances annuelles. Conformité incluse.",
      keywords: ["logiciel ramonage", "certificat ramonage", "planning ramoneur", "gestion ramonage", "ramonage cheminée"]
    },

    couvreurs: {
      title: "Logiciel Couvreur - Devis Toiture & Chantiers | LYS",
      metaDescription: "Logiciel de gestion couvreurs : devis toiture, calcul matériaux, planning chantiers, facturation. Module étanchéité inclus.",
      keywords: ["logiciel couvreur", "devis toiture", "calcul couverture", "planning couvreur", "gestion toiture"]
    }
  }
};

// Générateur d'URLs SEO optimisées
export const generateSEOUrls = (metier, cities = []) => {
  const baseUrls = [
    `/${metier}`,
    `/${metier}-logiciel`,
    `/logiciel-${metier}`,
    `/gestion-${metier}`
  ];

  const cityUrls = cities.flatMap(city => [
    `/${metier}-${city.name.toLowerCase()}`,
    `/${metier}-${city.name.toLowerCase().replace(/\s+/g, '-')}`,
    `/logiciel-${metier}-${city.name.toLowerCase()}`,
    `/${metier}-${city.name.toLowerCase()}-devis`
  ]);

  return [...baseUrls, ...cityUrls];
};

// Générateur de Schema.org markup
export const generateSchemaMarkup = (metier, config) => {
  const baseSchema = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebSite",
        "@id": `${seoConfig.siteUrl}/#website`,
        "url": seoConfig.siteUrl,
        "name": seoConfig.siteName,
        "description": `Logiciel de gestion pour ${metier}`,
        "potentialAction": [{
          "@type": "SearchAction",
          "target": {
            "@type": "EntryPoint",
            "urlTemplate": `${seoConfig.siteUrl}/search?q={search_term_string}`
          },
          "query-input": "required name=search_term_string"
        }]
      },
      {
        "@type": "WebPage",
        "@id": `${seoConfig.siteUrl}/${metier}/#webpage`,
        "url": `${seoConfig.siteUrl}/${metier}`,
        "name": config.title,
        "isPartOf": { "@id": `${seoConfig.siteUrl}/#website` },
        "description": config.metaDescription,
        "breadcrumb": {
          "@type": "BreadcrumbList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "Accueil",
              "item": seoConfig.siteUrl
            },
            {
              "@type": "ListItem", 
              "position": 2,
              "name": metier.charAt(0).toUpperCase() + metier.slice(1),
              "item": `${seoConfig.siteUrl}/${metier}`
            }
          ]
        }
      },
      {
        ...config.schema,
        "@id": `${seoConfig.siteUrl}/${metier}/#software`,
        "url": `${seoConfig.siteUrl}/${metier}`,
        "image": `${seoConfig.siteUrl}/images/${metier}-software.jpg`,
        "screenshot": `${seoConfig.siteUrl}/images/${metier}-dashboard.jpg`,
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.8",
          "reviewCount": "127",
          "bestRating": "5"
        },
        "review": [
          {
            "@type": "Review",
            "reviewRating": {
              "@type": "Rating", 
              "ratingValue": "5",
              "bestRating": "5"
            },
            "author": {
              "@type": "Person",
              "name": "Jean-Pierre M."
            },
            "reviewBody": `Excellent logiciel pour ${metier}, très intuitif et complet.`
          }
        ]
      },
      {
        "@type": "Organization",
        "@id": `${seoConfig.siteUrl}/#organization`,
        "name": "LYS",
        "url": seoConfig.siteUrl,
        "logo": {
          "@type": "ImageObject",
          "url": `${seoConfig.siteUrl}/images/lys-logo.png`
        },
        "contactPoint": {
          "@type": "ContactPoint",
          "telephone": "+33-1-23-45-67-89",
          "contactType": "customer service",
          "availableLanguage": "French"
        },
        "sameAs": [
          "https://www.facebook.com/LYSArtisans",
          "https://www.linkedin.com/company/lys-artisans",
          "https://twitter.com/LYSArtisans"
        ]
      }
    ]
  };

  return JSON.stringify(baseSchema, null, 2);
};

// Générateur de méta tags
export const generateMetaTags = (metier, config, city = null) => {
  const title = city 
    ? `${config.title.replace('|', `${city} |`)}`
    : config.title;
    
  const description = city
    ? `${config.metaDescription} Spécialiste ${city} et région.`
    : config.metaDescription;

  return {
    title,
    description,
    keywords: config.keywords?.join(', '),
    openGraph: {
      title,
      description,
      url: `${seoConfig.siteUrl}/${metier}${city ? `-${city.toLowerCase()}` : ''}`,
      siteName: seoConfig.siteName,
      image: `${seoConfig.siteUrl}/images/${metier}-og.jpg`,
      type: 'website',
      locale: 'fr_FR'
    },
    twitter: {
      card: 'summary_large_image',
      site: seoConfig.twitterHandle,
      title,
      description,
      image: `${seoConfig.siteUrl}/images/${metier}-twitter.jpg`
    },
    canonical: `${seoConfig.siteUrl}/${metier}${city ? `-${city.toLowerCase()}` : ''}`,
    robots: 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'
  };
};

export default seoConfig;